export default __webpack_public_path__ + "static/media/bonusBox_open_shine.6daeaa48.webp";